import { type FC } from "react";

import { t } from "i18n/i18n";
import { Listbox } from "mds/components/Listbox";
import { FolderIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { courseGroupingSelectors } from "store/selectors/base";
import { ADMIN_COURSE_EVENT_PREFIX } from "utils/amplitude";

type CourseGroupingDropdownProps = {
  selectedGroupingId: string | null;
  onSelectionChange: (groupingId: string | null) => void;
  id?: string;
  disabled?: boolean;
  "aria-invalid"?: boolean;
  "aria-describedby"?: string;
  "aria-required"?: boolean;
};

export const CourseGroupingDropdown: FC<CourseGroupingDropdownProps> = ({
  selectedGroupingId,
  onSelectionChange,
  id,
  disabled,
  "aria-invalid": ariaInvalid,
  "aria-describedby": ariaDescribedBy,
  "aria-required": ariaRequired,
}) => {
  const groupings = useAppSelector(courseGroupingSelectors.selectAll);

  const dropdownItems = [
    {
      id: "",
      title: t("home.courses.select_a_grouping"),
    },
    ...groupings.map((grouping) => ({
      id: grouping.id,
      title: grouping.title,
      iconStart: <FolderIcon />,
    })),
  ];

  return (
    <Listbox
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      aria-required={ariaRequired}
      buttonText={!selectedGroupingId ? t("home.courses.select_a_grouping") : undefined}
      className="flex w-full items-center !justify-between"
      disabled={disabled}
      eventName={`${ADMIN_COURSE_EVENT_PREFIX}Add Course - Select Folder`}
      id={id}
      items={dropdownItems}
      selectedValue={selectedGroupingId || ""}
      onSelectionChange={(item) => {
        onSelectionChange(item.id === "" ? null : item.id);
      }}
    />
  );
};
